export const CC_WEBSOCKET = 'CC_WEBSOCKET'

export default {
    CC_WEBSOCKET
}
